type PublicAppReturnPayload = {
  tenantId: string;
  ownerUserId: number;
  continuitySessionKey: string;
  selectedTeam?: string;
  submittedUrl?: string;
};

const PUBLIC_APP_RETURN_SCHEME = 'runai-public://public-handoff';
const PUBLIC_ANDROID_WEBVIEW_MARKER = 'RunAIAndroidPublic/1.0';

export function buildPublicAppReturnUrl(params: {
  currentUserId?: string;
  search?: string;
  userAgent?: string;
}) {
  const {
    currentUserId,
    search = window.location.search,
    userAgent = window.navigator.userAgent,
  } = params;
  if (!currentUserId || !/^\d+$/.test(currentUserId)) {
    return undefined;
  }
  if (!userAgent.includes(PUBLIC_ANDROID_WEBVIEW_MARKER)) {
    return undefined;
  }

  const searchParams = new URLSearchParams(search.startsWith('?') ? search : `?${search}`);
  if (searchParams.get('run_source') !== 'saas') {
    return undefined;
  }

  const returnTo = searchParams.get('run_return_to')?.trim() || '';
  if (returnTo !== PUBLIC_APP_RETURN_SCHEME) {
    return undefined;
  }

  const ownerUserId = Number(currentUserId);
  const selectedTeam = searchParams.get('run_entry_path') || 'customer-service';
  const submittedUrl = searchParams.get('run_store_url') || undefined;
  const payload: PublicAppReturnPayload = {
    tenantId: `run-${ownerUserId}`,
    ownerUserId,
    continuitySessionKey: `agent:run-sage-${ownerUserId}:teamgram:dm:${ownerUserId}`,
    ...(selectedTeam ? { selectedTeam } : {}),
    ...(submittedUrl ? { submittedUrl } : {}),
  };

  const next = new URL(PUBLIC_APP_RETURN_SCHEME);
  next.searchParams.set('payload', JSON.stringify(payload));
  return next.toString();
}
